import { css } from 'aphrodite';
import * as React from 'react';
import { useHistory } from 'react-router';
import { Checkbox } from '../../../../web/components-v2/Checkbox';
import { Label } from '../../../../web/components-v2/Label';
import { LoadingSpinner } from '../../../../web/components/LoadingSpinner';
import { LeadRule } from '../../../components/LeadRule';
import { useBlitzes } from '../../../queries/Blitzes';
import { FieldKey } from '../../../viewModels/form';
import { LeadRuleViewModel } from '../../../viewModels/leadrules';
import { BasicPage } from '../../BasicPage';
import { IVerticalSelectOption, VerticalSelect } from '../Blitzes/components/VerticalSelect';
import { styleSheet } from '../Blitzes/styles';

export const StartABlitz: React.FC = () => {
	const [selectedVertical, setVertical] = React.useState<FieldKey>(FieldKey.Unknown);

	const [showInactive, setShowInactive] = React.useState(false);

	const blitzesQuery = useBlitzes({
		onlyForUser: true,
	});

	const history = useHistory();

	const handleSelect = (selected: IVerticalSelectOption) => {
		setVertical(selected.dataContext as FieldKey);
	};

	const rules = blitzesQuery?.data?.values || [];

	const listOfUniqueVerticals = rules
		?.filter(item => item?.verticals?.length > 0)
		.map(item => [...(item?.verticals ?? [])])
		.reduce((acc, item) => acc.concat(item), []);

	const verticalOptions: IVerticalSelectOption[] = listOfUniqueVerticals
		?.filter((item, index) => listOfUniqueVerticals.indexOf?.(item) === index)
		.map(item => ({
			dataContext: item,
			id: item,
			text: item,
		}));

	verticalOptions.unshift({
		dataContext: FieldKey.Unknown,
		id: 'all',
		text: 'All Lead Pools',
	});

	const filterRulesByVertical = (rule: LeadRuleViewModel) => {
		if (selectedVertical === FieldKey.Unknown) {
			return rule;
		}
		if (rule.verticals.indexOf(selectedVertical) !== -1) {
			return rule;
		}
	};

	const handleToggle = () => {
		setShowInactive(!showInactive);
	};

	const handleClickToPlayBlitz = (ruleId: string) => () => {
		history.push(`/queue?ruleId=${ruleId}`);
	};

	return (
		<BasicPage appearance='light' title='Start a Blitz'>
			<div className={css(styleSheet.page)}>
				<div className={css(styleSheet.listHeader)}>
					<VerticalSelect options={verticalOptions} disabled={verticalOptions?.length <= 1} onChange={handleSelect} />
					<Label htmlFor='show-inactive-lead-rules' styles={[styleSheet.toEnd]}>
						<Checkbox id='show-inactive-lead-rules' checked={showInactive} onCheckedChange={handleToggle} />
						Show Inactive
					</Label>
				</div>
				{blitzesQuery.isPending ? (
					<LoadingSpinner type='large' />
				) : (
					<div>
						{rules?.filter(filterRulesByVertical)?.map(rule => {
							if (!showInactive && !rule.isEnabled) {
								return null;
							}
							return (
								<div key={rule.id}>
									<LeadRule
										isPlayable
										isReadonly={rule.type !== 'CustomLeadRule'}
										leadRule={rule}
										leadRules={rules}
										onClickToPlayBlitz={handleClickToPlayBlitz(rule.id)}
									/>
								</div>
							);
						})}
					</div>
				)}
			</div>
		</BasicPage>
	);
};
